import { render, staticRenderFns } from "./DictionaryData.vue?vue&type=template&id=0a769df9&scoped=true&"
import script from "./DictionaryData.vue?vue&type=script&lang=js&"
export * from "./DictionaryData.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryData.vue?vue&type=style&index=0&id=0a769df9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a769df9",
  null
  
)

export default component.exports